export enum DacadooEndpoints {
    IsClient = "ux-consulta-clientes-dacadoo/servicio-al-cliente/mep/v1/clientes/dacadoo",
}
